import { render, staticRenderFns } from "./EditAdditionalDetails.vue?vue&type=template&id=b19ea41c&scoped=true"
import script from "./EditAdditionalDetails.vue?vue&type=script&lang=js"
export * from "./EditAdditionalDetails.vue?vue&type=script&lang=js"
import style0 from "./EditAdditionalDetails.vue?vue&type=style&index=0&id=b19ea41c&prod&scoped=true&lang=css"
import style1 from "./EditAdditionalDetails.vue?vue&type=style&index=1&id=b19ea41c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19ea41c",
  null
  
)

export default component.exports